import { citrusStyled } from '@citrus/runtime';
export var Chart = citrusStyled.div('N/A', null);
export var Styled = {
    Chart: Chart,
};
